const { map, merge } = require('ramda')
const { curry } = require('yafu')

const defaultOverrides = { allowCreateInline: true }

const adjustVehicle = curry((opts) => map((item) => {
  const overrides = merge(defaultOverrides, opts)
  const { key } = item
  return key === 'mediaVehicle' ? merge(item, overrides) : item
}))

module.exports = adjustVehicle
